import React, { useState } from 'react'
import AppFrame from '../AppFrame'
import { useQuery } from "@apollo/client"
import { useNavigate } from "react-router-dom"
import { get } from 'lodash'

import SectionHeader from '../components/SectionHeader'
import ButtonStep from '../components/ButtonStep'
import BackButton from '../components/BackButton'
import { QUERY_BIO_DATA } from '../data/services/graphqlQueries'
import Loading from '../components/Loading'

export default ({globalData, slug, category}) => {
  const { loading, error, data } = useQuery(QUERY_BIO_DATA, {
    notifyOnNetworkStatusChange: true,
    variables: {
      category: category,
      slug: slug
    }
  })

  if (loading) {
    return <AppFrame data={globalData}>
    <div className="max-w-6xl mx-auto">
      <Loading />
    </div>
  </AppFrame>
  }

  const bio = get(data, "bios[0]")

  if (!bio) {
    return  <AppFrame data={globalData}>
              <div className="max-w-6xl mx-auto">
                Not found.
              </div>
            </AppFrame>
  }

  return (
    <AppFrame data={globalData}>
      <div className="max-w-6xl mx-auto mt-8 mb-12 px-8">

        <SectionHeader title={bio.name} subtitle={category} />
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <img className="w-full" src={get(bio, 'image.url')} />
          </div>
          <div className="col-span-2">
             <div className="ecs-html mb-12" dangerouslySetInnerHTML={{__html: bio.body}}></div>
             <div className="col-span-2 ">
              <BackButton />
            </div>
          </div>        
        </div>
      </div>
    </AppFrame>
  )
}